/** Chiavi peer/sessione nel payload push (mai queueId del destinatario). */
export const PUSH_PEER_ID_KEYS = [
  'peerId',
  'senderId',
  'chatId',
  'senderSessionToken',
  'fromSessionToken',
  'peerSessionToken',
] as const

/** Chiavi nickname nel payload — solo per lookup locale, mai come titolo banner. */
export const PUSH_NAME_HINT_KEYS = [
  'nickname',
  'username',
  'displayName',
  'senderName',
] as const

export function isHexSessionId(value: string): boolean {
  const s = value.trim()
  if (!s) return true
  return /^[a-f0-9-]{8,}$/i.test(s)
}

export function isGenericPushLabel(value: string): boolean {
  const s = value.trim().toLowerCase()
  if (!s) return true
  if (s === 'zion' || s === 'nuovo messaggio' || s === 'new message') return true
  if (s.includes('hai ricevuto') || s.includes('nuovo messaggio')) return true
  return false
}

export function peerKeyVariants(peerId: string): string[] {
  const raw = peerId.trim().toLowerCase()
  if (!raw) return []
  const out = [raw]
  if (raw.startsWith('@')) out.push(raw.slice(1))
  else out.push(`@${raw}`)
  return [...new Set(out)]
}

function pushHintValue(data: Record<string, unknown>, key: string): string {
  const direct = String(data[key] || '').trim().toLowerCase()
  if (direct) return direct
  const nested = data.data
  if (nested && typeof nested === 'object') {
    return String((nested as Record<string, unknown>)[key] || '').trim().toLowerCase()
  }
  return ''
}

/** Tutti gli ID/hint utili per trovare il contatto locale (non per il titolo). */
export function collectPeerHintsFromPushData(
  data: Record<string, unknown> | null | undefined,
): string[] {
  if (!data || typeof data !== 'object') return []
  const out: string[] = []
  for (const k of PUSH_PEER_ID_KEYS) {
    const s = pushHintValue(data, k)
    if (s) out.push(s)
  }
  for (const k of PUSH_NAME_HINT_KEYS) {
    const s = pushHintValue(data, k)
    if (!s || isGenericPushLabel(s) || isHexSessionId(s)) continue
    out.push(s)
  }
  return [...new Set(out)]
}
